// extracted by mini-css-extract-plugin
export default {"root":"_1jbKE","animator":"_3_sbP","notification-link":"_1tmLd","notificationLink":"_1tmLd"};